// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1sQxB","savePackageButton":"ClientWallet_savePackageButton__3r2m6"};